import { AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import bgImage from "../../../assets/12.jpg";
import { isAuthenticated } from "../../../services/auth.api";
import "../styles/auth.css";
import BrandCard from "./BrandCard";
import ForgetPasswordForm from "./ForgetPasswordForm";
import LoginForm from "./LoginForm";
import RegisterForm from "./RegisterForm";
import VerificationForm from "./VerificationForm";

const AuthContainer = () => {
  const navigate = useNavigate();
  const { step } = useParams();
  // The phone the OTP was sent to, carried from login/register to the code screen.
  const [pendingPhone, setPendingPhone] = useState("");

  // send back to home if already logged in
  useEffect(() => {
    if (isAuthenticated()) {
      navigate("/");
    }
  }, [navigate]);

  return (
    <div
      className="min-vh-100 d-flex flex-column flex-md-row align-content-center justify-content-center p-4"
      style={{ backgroundColor: "#F5F6FA" }}
    >
      {/* Background overlay */}
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{ opacity: 0.1 }}
      >
        <img
          src={bgImage}
          alt="Own Food"
          className="w-100 h-100"
          style={{ objectFit: "cover" }}
        />
      </div>

      <div
        className="position-relative w-100 bg-white overflow-hidden auth-card"
        style={{
          maxWidth: "72rem",
          borderRadius: "1.5rem",
          height: "fit-content",
        }}
      >
        <div className="d-flex flex-column flex-lg-row gap-lg-1">
          {/* Left side - Brand card */}
          <BrandCard />

          {/* Right side - Auth form */}
          <div className="w-100 d-flex align-items-center justify-content-center p-2 p-lg-0">
            <div className="w-100">
              <AnimatePresence mode="wait">
                {step === "login" && (
                  <LoginForm
                    key="login"
                    onRequireVerification={(phone) => {
                      setPendingPhone(phone);
                      navigate(`/authentication/verify`);
                    }}
                  />
                )}

                {step === "register" && (
                  <RegisterForm
                    key="register"
                    onRequireVerification={(phone) => {
                      setPendingPhone(phone);
                      navigate(`/authentication/verify`);
                    }}
                  />
                )}

                {step === "verify" && (
                  <VerificationForm
                    key="verify"
                    phone={pendingPhone}
                    goback={() => navigate("/authentication/login")}
                    onVerify={() => {
                      window.location.href ="/";
                    }}
                  />
                )}

                {step === "forget-password" && (
                  <ForgetPasswordForm
                    key="forget-password"
                  />
                )}
              </AnimatePresence>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthContainer;
